import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Typography, IconButton } from "@material-ui/core";
import { Close as CloseIcon, GetApp as DownloadIcon } from "@material-ui/icons";

export default function DownloadDialog({
  open,
  onClose,
  downloadInProgress,
}) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 16,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          textAlign: "center", 
          fontWeight: 600,
          fontSize: "1.25rem",
          color: "text.primary",
          paddingBottom: 1,
          position: "relative"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <DownloadIcon sx={{ color: "primary.main" }} />
          Download Progress
        </Box>
        <IconButton
          onClick={onClose}
          disabled={downloadInProgress}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "action.hover",
            }
          }}
        >
         
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ paddingTop: 0 }}>
        {downloadInProgress ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 4,
              gap: 3,
              minHeight: 155,
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress
                size={80}
                thickness={4}
                sx={{ 
                  color: "primary.main",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))"
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "primary.main",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DownloadIcon sx={{ color: "white", fontSize: 16 }} />
              </Box>
            </Box>
            
            <Box sx={{ textAlign: "center", gap: 1 }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: "text.primary",
                  fontWeight: 500,
                  marginBottom: 1
                }}
              >
                Preparing Download...
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: "text.secondary",
                  maxWidth: 300,
                  lineHeight: 1.6,
                  marginBottom: "3px"
                }}
              >
                Please wait while we prepare your file. This may take a few moments.
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box 
            sx={{ 
              textAlign: "center", 
              padding: 4,
              minHeight: 120,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2
            }}
          >
            <Box
              sx={{
                backgroundColor: "grey.100",
                borderRadius: "50%",
                width: 60,
                height: 60,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 1
              }}
            >
              <DownloadIcon sx={{ color: "text.secondary", fontSize: 28 }} />
            </Box>
            <Typography 
              variant="body1" 
              sx={{ 
                color: "text.primary",
                fontWeight: 500
              }}
            >
              No download in progress
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: "text.secondary",
                maxWidth: 250
              }}
            >
              Start a download to see progress here
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}